"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = require("../Button/Button");
function ModalFooter({ size, onCloseButtonClick, footerButtonText, onFooterButtonClick }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('h-24', 'flex', 'items-center', 'px-6', {
            'justify-end': size === 'medium' || size === 'large'
        }) }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({ onClick: onFooterButtonClick ? onFooterButtonClick : onCloseButtonClick, className: (0, classnames_1.default)({
                'w-full': size === 'small' || size === 'x-small'
            }) }, { children: footerButtonText })) })));
}
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map